import cx from 'classnames';
import Button from 'components/Form/Button';
import Icon from 'components/Icon';
import { withHandlers } from 'recompose';

import styles from './styles.css';

const Notification = withHandlers<Notification, Notification>({
  onRemove:
    ({ onRemove, id }) =>
    (e) =>
      onRemove(id),
})(({ title, type, text, button, onRemove }: any) => (
  <div className={cx(styles.item, styles[type])}>
    <div className={styles.wrap}>
      <div className={styles.content}>
        <div>
          {title && <h3 className={styles.title}>{title}</h3>}
          <div className={styles.text}>{text}</div>
        </div>

        {button && (
          <Button onClick={() => button.onClick()} className={styles.button}>
            {button.title}
          </Button>
        )}
      </div>
      <a className={styles.close} onClick={onRemove}>
        <Icon name="close" width={17} height={17} />
      </a>
    </div>
  </div>
));

export default ({ notifications, remove }: Props) => (
  <div className={cx(styles.root, !!notifications.length && styles.active)}>
    <Icon name="notification" width={24} height={24} className={styles.icon} />
    <div className={styles.notifications}>
      {notifications.map((notification: Notification) => {
        return (
          <Notification
            {...notification}
            key={notification.id}
            onRemove={remove}
          />
        );
      })}
    </div>
  </div>
);

export interface Notification {
  id: string;
  text: string;
  type: string;
  button: any;
  onRemove: (id: string) => void;
}

export interface Props {
  notifications: Notification[];
  remove: (id: string) => void;
}
